/* Suresh Peddavoora 10/26/2022 3075154998  Changed Text Field Variant from outlined to standard
Suresh Peddavoora 10/31/2022 3075154998  Changed class name for Text Fields
Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
*/

import React, {useContext, useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, FormControl, Button} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import SearchTable from './SearchTable';
import {getDropDownData} from '../../../../../redux/reducers/EnableFramework/Filter';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {useSelector, useDispatch} from 'react-redux';
import {resetFilterGroupData} from '../../../../../redux/reducers/DMFilterGroup';
import {getOptions} from './../../../../../util/GetDropDownOptions';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
export default function SearchDataManagerFilterGroup({setValue}) {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const {dropDownData} = useSelector(({filter}) => filter);
  const initialValues = {
    groupCode: '',
    description: '',
    accessType: null,
    groupType: null,
  };

  const {handleSubmit, control, reset, errors} = useForm({
    mode: 'all',
    defaultValues: initialValues,
  });

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const onSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(resetFilterGroupData());
  }, []);
  return (
    <>
      <div className={`mb-0`}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-row align-items-center standard-field-textfields">
            <div className="col-sm-6 col-md-3 col-lg-3 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={`${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Code"
                      margin="dense"
                      name="code"
                      variant="standard"
                      label="Code"
                      value={value?.toUpperCase()}
                      onChange={onChange}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="code"
                />
              </FormControl>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-4 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={`${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Description"
                      margin="dense"
                      name="description"
                      variant="standard"
                      label="Description"
                      value={value}
                      onChange={onChange}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="description"
                />
              </FormControl>
            </div>

            <div className="col-sm-6 col-md-3 col-lg-3 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="recordType"
                      options={getOptions(RECORD_TYPE, dropDownData)}
                      size="small"
                      autoHighlight
                      getOptionDisabled={(option) => option.valueCode === 'none'}
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            option.value ?
                              option.value :
                              '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          variant="standard"
                          fullWidth
                          label="Record Type"
                          name="recordType"
                          error={Boolean(errors?.accessType?.message)}
                          placeholder="Select Record Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="recordType"
                  control={control}
                />
              </FormControl>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-2 form-group">
              <Button
                type="button"
                onClick={() => {
                  reset(initialValues);
                }}
                variant="outlined"
                className={`reset-btn mx-1 ${classes.buttonRoot}`}
              >
              Reset
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`search-btn mx-1 ${classes.buttonRoot}`}
                color="primary"
              >
              Search
              </Button>
            </div>
          </div>


        </form>

        <div>
          <SearchTable
            searchData={searchData}
            setSearchData={setSearchData}
            submit={submit}
            setSubmit={setSubmit}
            setValue={setValue}
          />
        </div>
      </div>
    </>
  );
}
